<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>绑定老师记录</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="90" :show-message="false" label-position="right">
        <Row :gutter="16">
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="操作人">
              <Input placeholder="支持模糊搜索" name="operator"
                     v-model="queryParam.operator"></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="操作日期:">
              <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd" type="daterange"
                          placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="老师">
              <Input placeholder="ID/Name" name="tchName"
                     v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="学生">
              <Input placeholder="ID/手机号" name="userName"
                     v-model="queryParam.userName"></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="操作">
                <Select v-model="queryParam.operation" clearable>
                  <Option value="1" key="1">绑定</Option>
                  <Option value="2" key="2">解绑</Option>
                </Select>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="删除原因">
                <Select v-model="queryParam.delReason" clearable>
                  <Option value="1" key="1">离职老师</Option>
                  <Option value="2" key="2">关时间老师</Option>
                  <Option value="3" key="3">淘汰老师</Option>
                  <Option value="4" key="4">其它</Option>
                  <Option value="5" key="5">老师请假</Option>
                  <Option value="6" key="6">教学不好</Option>
                </Select>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item label="操作说明">
              <Input placeholder="模糊搜素" name="remark"
                     v-model="queryParam.remark"></Input>
            </Form-item>
          </Col>
          <Col :xs="24" :sm="12" :md="8" :lg="6">
            <Form-item>
              <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
              <Button type="primary" :loading="exportLoading" :disable="exportLoading" @click="exportData" style="margin-left: 8px;">导出</Button>
            </Form-item>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="operation-log/list/user-bind-teacher"
          :params="queryParam" :onLoading="onLoading" operator="" :stripe="false" :rowClassName="rowClass"></List>
  </div>
</template>
<style>

</style>
<script>

export default {
  components: {},
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      queryParam: {
        operator: '',
        startTime: '',
        endTime: '',
        startTimeDate: '',
        endTimeDate: '',
        tchId: '',
        tchName: '',
        userId: '',
        userName: '',
        operation: '',
        delReason: '',
      },
      title: [
        {
          title: '学生ID/姓名',
          align: 'center',
          width: 200,
          render: (h, params) => {
            let row = params.row
            if (!row.groupHead) {
              return h('span', '')
            }
            return h('div', [
              h('span', row.uid),
              h('span', ' - '),
              h('span', row.stdName)
            ])
          }
        },
        {
          title: '操作人',
          align: 'center',
          width: 120,
          render: (h, params) => {
            if (!params.row.groupHead) {
              return h('span', '')
            }
            return h('span', params.row.creatorName)
          }
        },
        {
          title: '操作时间',
          align: 'center',
          width: 180,
          render: (h, params) => {
            if (!params.row.groupHead) {
              return h('span', '')
            }
            return h('span', params.row.gmtCreate)
          }
        },
        {
          title: '绑定内容',
          width: 380,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let startTime = $moment.unix(row.startTime).utc().format('HH:mm')
            let children = [
              h('span', {style: {color: '#2d8cf0'}}, row.tchId + '-' + row.tchName),
              h('span', ' [' + $constant.weekZh[row.week] + startTime + ']')
            ]
            if (row.delReasonText) {
              children.push(h('span', ' ' + row.delReasonText))
            }
            return h('div', {style: {'font-size': '12px'}}, children)
          }
        },
        {
          title: '绑定/解绑',
          align: 'center',
          width: 110,
          render: (h, params) => {
            let row = params.row
            let text = row.status === 1 ? '绑定' : '解绑'
            let color = row.status === 1 ? '#19be6b' : '#ed4014'
            return h('span', {
              style: {
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作说明',
          align: 'center',
          width: 260,
          key: 'remark'
        },
      ]
    }
  },
  mounted: function () {
    this.$nextTick(() => {
      let body = this.$el.querySelector('.ivu-table-body')
      if (!body) {
        return
      }
      this.tableObserver = new MutationObserver(() => {
        this.mergeGroupCells()
      })
      this.tableObserver.observe(body, {childList: true, subtree: true})
      this.mergeGroupCells()
    })
  },
  beforeDestroy: function () {
    if (this.tableObserver) {
      this.tableObserver.disconnect()
    }
  },
  created: function () {
  },
  methods: {
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    startTimeDateChange (value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange (value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    exportData () {
      this.exportLoading = true
      this.$http.get('/operation-log/export/user-bind-teacher', {responseType: 'arraybuffer', params: this.queryParam}).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '绑定老师记录.xlsx'
          link.click()
          this.$Message.success('导出成功')
        } else {
          this.$Message.error(response.msg || '导出失败')
        }
        this.exportLoading = false
      }).catch((error) => {
        this.$Message.error('导出失败：' + error.message)
        this.exportLoading = false
      })
    },
    atimeDateChange (value) {
      this.queryParam.startDate = value[0]
      this.queryParam.endDate = value[1]
    },
    rowClass (row) {
      let cls = row.groupSeq % 2 === 1 ? 'op-group-odd' : 'op-group-even'
      if (row.groupHead) {
        cls += ' op-group-head'
      }
      return cls
    },
    mergeGroupCells () {
      if (this.merging) {
        return
      }
      let body = this.$el.querySelector('.ivu-table-body tbody')
      if (!body) {
        return
      }
      let rows = Array.prototype.filter.call(body.children, function (tr) {
        return tr.classList.contains('ivu-table-row')
      })
      if (!rows.length) {
        return
      }
      let already = rows.some(function (tr) {
        return !tr.classList.contains('op-group-head') && tr.children.length < 6
      })
      if (already) {
        return
      }
      this.merging = true
      let i = 0
      while (i < rows.length) {
        let j = i + 1
        while (j < rows.length && !rows[j].classList.contains('op-group-head')) {
          j++
        }
        let span = j - i
        if (span > 1) {
          for (let c = 0; c < 3; c++) {
            rows[i].children[c].rowSpan = span
            rows[i].children[c].style.verticalAlign = 'middle'
          }
          for (let r = i + 1; r < j; r++) {
            for (let c = 0; c < 3; c++) {
              rows[r].removeChild(rows[r].children[0])
            }
          }
        }
        i = j
      }
      this.merging = false
    }
  }
}
</script>

<style lang="less" scoped>
  .btn-wrap {
    text-align: right;
    margin-top: 24px;
    margin-bottom: 12px;
  }
  .search /deep/ .ivu-input,
  .search /deep/ .ivu-select {
    width: 100%;
  }
  .list /deep/ .ivu-table table {
    min-width: 1250px;
  }
  .list /deep/ .ivu-table-row.op-group-odd td {
    background-color: #f4f8fb;
  }
  .list /deep/ .ivu-table-row.op-group-head td {
    box-shadow: inset 0 2px 0 #d5dde6;
  }
  .list /deep/ .ivu-table-body td[rowspan] {
    vertical-align: middle;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// BindTeacherOperationRecord.vue?249b37e6